import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Page from '@Containers/Page';
import RouteChangeTracking from '@Services/RouteChangeTracking';

import './LoginPageWrapper.scss';

function LoginPageWrapper(props) {
  const { children, className, mainAriaLabel = 'Login screen' } = props;
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
  }, []);
  return (
    <Page
      withHeader
      headerType="unauth"
      withFooter
      className={classnames('react-page-static__wrapper', 'react-page-login-page', { [className]: className })}>
      <div className="login-page">
        <div id="hexagon-visuals" />
        <main id="main-content" className="login-page__screen" aria-label={mainAriaLabel}>
          <div className="login-page__screen_container rx-container rx-container--centered">
            <div className="login-page__screen_container-additional-text">
              <div className="login-page-form" role="form" aria-label={mainAriaLabel}>
                {children}
              </div>
            </div>
          </div>
        </main>
      </div>
    </Page>
  );
}

LoginPageWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  mainAriaLabel: PropTypes.string,
};

export default LoginPageWrapper;
